export { Icon, ICONS } from "./Icon";
